import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';

export const mainCls = 'csa-login-privacy';

export default {
  [mainCls]: {
    lineHeight: '20px', 
    '& a': {
      '@media (hover: hover)': {
        transition: createTransition(['color']),
        '&:hover': {
          color: `${colors.secondary.rgba} !important`,
        },
      },
    },
  },
};
